// Single Trainer (CPT `trainers`) — guarded so it only runs on single-trainers.php.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.single-trainer');
    if (!root) {
        return;
    }

    // Плавный скролл по внутренним якорям в описании тренера.
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(link.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
});
